var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Address-Icon",
    clipPath: "url(#clip0_7786_9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.125 8.25C19.125 10.0165 18.2719 12.377 16.8333 15.0476C15.581 17.3723 13.9726 19.7762 12.375 21.9909C10.7774 19.7762 9.16895 17.3723 7.91665 15.0476C6.47806 12.377 5.625 10.0165 5.625 8.25C5.625 4.52208 8.64708 1.5 12.375 1.5C16.1029 1.5 19.125 4.52208 19.125 8.25ZM20.625 8.25C20.625 12.5665 16.5863 18.8013 12.9726 23.7182C12.6756 24.1223 12.0744 24.1223 11.7774 23.7182C8.16373 18.8013 4.125 12.5665 4.125 8.25C4.125 3.69365 7.81865 0 12.375 0C16.9313 0 20.625 3.69365 20.625 8.25ZM12.375 11.25C14.0319 11.25 15.375 9.90685 15.375 8.25C15.375 6.59315 14.0319 5.25 12.375 5.25C10.7181 5.25 9.375 6.59315 9.375 8.25C9.375 9.90685 10.7181 11.25 12.375 11.25Z",
    fill: "#F7F8FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7786_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.b793313b7e76cb7adfc7938dcd35adf3.svg";
export { ForwardRef as ReactComponent };